var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.rttClass},[_c('div',{staticClass:"icon-rtt"}),(_vm.states.hasCurrentRoundTripTime)?_c('span',[_vm._v(_vm._s(_vm.states.currentRoundTripTime)+" ms")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }